import React from 'react';
import { Form, Input, Button, Icon, message as showMessage } from 'antd';
import styled from 'styled-components';
import API from '../../helper/api';
import finderLogo from '../../assets/finder_logo_red.png';
import { setItem } from '../../helper/utility';
import { withRouter } from 'react-router-dom';
import { postData } from '../../helper/dataService';
import CompleteRegistration from './CompleteRegistration';

class Login extends React.Component {
  state = {
    submitted: false,
    registrationComplete: true,
  };

  handleLogin = () => {
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (err) {
        return;
      }

      this.setState({ submitted: true });

      const data = {
        client_id: 'finder_admin',
        client_secret: 'f1nd3r@dm1n',
        grant_type: 'client_credentials',
        scope: '',
        login_type: 'normal',
        timezone: '-360',
        user: values.email,
        password: values.password,
      };

      postData(API.auth.login, data)
        .then(({ data }) => {
          this.setState({ submitted: false });

          if (data.status === 'failed') {
            showMessage.error(data.display);
            return;
          }

          if (data.status === 'success') {
            const { access_token, refresh_token } = data.data;
            const {
              name,
              email,
              mobile,
              mobile_verified,
              gender,
              religion,
              blood_group,
              birth_date,
            } = data.user;

            setItem('accessToken', access_token);
            setItem('refreshToken', refresh_token);
            setItem('name', name);
            setItem('email', email);

            const isProfileComplete =
              name &&
              email &&
              mobile &&
              mobile_verified &&
              gender &&
              religion &&
              blood_group &&
              birth_date;

            if (isProfileComplete) {
              // Redirect to home
              setItem('profileComplete', 'yes');
              showMessage.success(
                `Welcome, ${name.split(' ').splice(0, 2).join(' ')}`
              );
              this.props.history.push('/');
              return;
            }

            this.setState({ registrationComplete: false, submitted: false });
          }
        })
        .catch(() => {
          showMessage.error('Sorry! Something went wrong');
          this.setState({ submitted: false });
        });
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { submitted, registrationComplete } = this.state;

    if (registrationComplete) {
      return (
        <React.Fragment>
          <div className='center-of-page'>
            <LoginBox>
              <Logo src={finderLogo} alt='Finder Logo' />
              <Title>Admin Panel</Title>
              <Form
                layout='vertical'
                hideRequiredMark={true}
                style={{ width: '300px' }}
              >
                <Form.Item label='Email'>
                  {getFieldDecorator('email', {
                    rules: [
                      { required: true, message: 'Please input your email' },
                    ],
                  })(
                    <Input
                      prefix={
                        <Icon
                          type='mail'
                          style={{ color: 'rgba(0,0,0,.25)' }}
                        />
                      }
                      placeholder='Email'
                    />
                  )}
                </Form.Item>

                <Form.Item label='Password'>
                  {getFieldDecorator('password', {
                    rules: [
                      { required: true, message: 'Please input password' },
                    ],
                  })(
                    <Input
                      prefix={
                        <Icon
                          type='lock'
                          style={{ color: 'rgba(0,0,0,.25)' }}
                        />
                      }
                      type='password'
                      placeholder='Password'
                    />
                  )}
                </Form.Item>
              </Form>

              <Button
                style={{ width: '100%' }}
                type='primary'
                size='large'
                onClick={this.handleLogin}
                loading={submitted}
              >
                Log In
              </Button>
            </LoginBox>
          </div>
        </React.Fragment>
      );
    } else {
      return <CompleteRegistration />;
    }
  }
}

export default Form.create()(withRouter(Login));

const Logo = styled.img`
  display: block;
  width: 300px;
  height: 70px;
  margin-bottom: 10px;
`;

const Title = styled.p`
  font-size: 12px;
  font-weight: 400;
  text-transform: uppercase;
`;

const LoginBox = styled.div`
  border: 1px solid #fff;
  background-color: #fff;
  border-radius: 2px;
  padding: 40px 50px;
  box-shadow: 1px 2px 2px 2px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
